import db from '../firebaseConfig';
import { getWeekNumber } from '../util/dateTools';
import firebase from "@firebase/app";

function getConfCollectionName(mode) {
    if( mode === 'crypto') return 'usercryptoconfs';
    if( mode === 'usa') return 'userusaconfs';
    if( mode === 'pea') return 'userconfs';
    return 'oups';
}

function getWatchlistCollectionName(mode) {
    if( mode === 'crypto') return 'watchlistcrypto';
    if( mode === 'usa') return 'watchlistusa';
    if( mode === 'pea') return 'watchlist';
    return 'oups';
}

/* User conf */
export async function getUserConf(user, mode) {
    const result = await db.collection(getConfCollectionName(mode)).doc(user.uid).get();
    if (!result.exists) return false;
    const conf = result.data();
    for (const position of conf.positions) {
        if (!position.history) {
            position.history = [{
                t: +new Date() / 1000 - (1 * 24 * 60 * 60),
                q: position.quantity,
                v: position.value,
                s: -1
            }];
        }
    }
    return conf;
}
export async function createUserConf(user, conf, mode) {
    return db.collection(getConfCollectionName(mode)).doc(user.uid).set(conf);
}
export async function updateUserConf(user, conf, mode) {
    let newConf = {...conf}
    delete newConf.isPro;
    if( ! (await getUserConf(user, mode)) ) {
        return await createUserConf(user, newConf, mode);
    }
    return db.collection(getConfCollectionName(mode)).doc(user.uid).update(newConf);
}

// Position history
export async function addHistory(historyWrapper) {
    await db.collection('positionhistory').add(historyWrapper);
}
export async function getHistory(user, mode, from, to) {
    let result = await db.collection('positionhistory')
    .where('author_id', '==', user.uid)
    .where('t', '>=', from)
    .where('t', '<=', to)
    .where('mode', '==', mode)
        .get();
    let data = []
    if (result.size > 0) {
        data = result.docs.map(d =>( {...d.data(), uid:d.id}));
    }
    return data;
}

/* Watchlists */
export async function updateWatchlists(user, watchlists, mode) {
    return db.collection(getWatchlistCollectionName(mode)).doc(user.uid).set({
        d: watchlists
    });
}
export async function getWatchlists(user, mode) {
    const result = await db.collection(getWatchlistCollectionName(mode)).doc(user.uid).get();
    return result.exists ? await result.data().d : [];
}

/* Drawings */
export async function getDrawing(user, instrument) {
    let result = await db.collection('drawings')
    .where('author_id', '==', user.uid)
    .where('isin', '==', instrument.isin)
    .get();
    let data = {}
    if (!result.size) {
        data = {
            author_id: user.uid,
            isin: instrument.isin,
        };
        result = await db.collection('drawings').add(data);
        data.uid = result.id;
    } else {
        data = result.docs[0].data()
        data.uid = result.docs[0].id;
    }
    return data;
}
export async function updateDrawings(drawings) {
    return db.collection('drawings').doc(drawings.uid).set(drawings);
}

/* Donation */
export async function addDonation(donation) {
    return db.collection('donations').add(donation);
}

/* Quote History */
export async function getQuoteWeeklyHistory(instrument) {
    const snapshot = await db.collection('weekly').doc(instrument.isin).get();
    const document = snapshot.data();
    
    let quotes = document.d
    .sort( (a,b) => a.t - b.t)
    .map(q => [
        q.t*1000,
        q.o,
        q.h,
        q.l,
        q.c,
        q.v
    ]);
    // Add current value to graph
    let lastQuote = quotes[quotes.length-1];
    // Si on est la même semaine ou sur les cryptos
    if(lastQuote && getWeekNumber(lastQuote[0]) === getWeekNumber(instrument.li.t*1000)
    && instrument.li.o && instrument.li.t*1000 > lastQuote[0] || instrument.ty === 'Crypto') {
        quotes[quotes.length-1] = [
            instrument.li.t*1000,
            lastQuote[1],
            lastQuote[2] > instrument.li.h ? lastQuote[2] : instrument.li.h,
            lastQuote[3] < instrument.li.l ? lastQuote[3] : instrument.li.l,
            instrument.li.last,
            lastQuote[5] + instrument.li.v
        ]
    } // Pas la même semaine (lundi en général)
    else if(lastQuote && getWeekNumber(lastQuote[0]) !== getWeekNumber(instrument.li.t*1000)
    && instrument.li.o && instrument.li.t*1000 > lastQuote[0] ){
        quotes.push([
            instrument.li.t*1000,
            instrument.li.o,
            instrument.li.h,
            instrument.li.l,
            instrument.li.last,
            instrument.li.v
        ]);
    }  
    return quotes;
}

/* Notes */
export async function addNote(user, note) {
    return await db.collection('notes').add({
        author_id: user.uid,
        ...note,
        t: +new Date() / 1000
    });
}

export async function deleteNote(uid) {
    return await db.collection('notes')
    .doc(uid)
    .delete();
}

export async function searchNotes(user, instrument, mode, limit) {
    let result;
    if (instrument) {
        result = await db.collection('notes')
        .where('author_id', '==', user.uid)
        .where('isin', '==', instrument.isin)
        .where('mode', '==', mode)
        .orderBy("t", "desc")
        .limit(limit)
        .get();
    } else {
        result = await db.collection('notes')
        .where('author_id', '==', user.uid)
        .where('mode', '==', mode)
        .orderBy("t", "desc")
        .limit(limit)
        .get();
    }
    let data = []
    if (result.size > 0) {
        data = result.docs.map(d => ({
            uid: d.id,
            data: d.data()
        }));
    }
    return data;
}


export async function getQuoteDailyHistory(instrument) {
    const snapshot = await db.collection('daily').doc(instrument.isin).get();
    const document = snapshot.data();
    
    let quotes = document.d
    .sort( (a,b) => a.t - b.t)
    .map(q => [
        (q.t - q.t % (24 * 60 * 60) )*1000,
        q.o,
        q.h,
        q.l,
        q.c,
        q.v
    ]);
    // Add current value to graph
    let lastQuote = quotes[quotes.length-1];
    // Si on est le même jour
    const lastQuoteDate = new Date(lastQuote[0]);
    const currentQuoteDate = new Date(instrument.li.t*1000)
    const isSameDay = (lastQuoteDate.getDate() === currentQuoteDate.getDate() 
    && lastQuoteDate.getMonth() === currentQuoteDate.getMonth()
    && lastQuoteDate.getFullYear() === currentQuoteDate.getFullYear())
    
    if( !isSameDay && instrument.li.o ){
        quotes.push([
            instrument.li.t*1000,
            instrument.li.o,
            instrument.li.h,
            instrument.li.l,
            instrument.li.last,
            instrument.li.v
        ]);
    } else if (instrument.ty === "Crypto") {
        quotes[quotes.length-1] = [
            instrument.li.t*1000,
            lastQuote[1],
            lastQuote[2] > instrument.li.h ? lastQuote[2] : instrument.li.h,
            lastQuote[3] < instrument.li.l ? lastQuote[3] : instrument.li.l,
            instrument.li.last,
            lastQuote[5] + instrument.li.v
        ]
    }
    return quotes;
}

export async function openStripeDashboard(){
    const functionRef = firebase
        .app()
        .functions("europe-west1")
        .httpsCallable("ext-firestore-stripe-payments-createPortalLink");
      const { data } = await functionRef({
        returnUrl: window.location.href,
        locale: "auto" // Optional, defaults to "auto"
        // configuration: "bpc_1JSEAKHYgolSBA358VNoc2Hs", // Optional ID of a portal configuration: https://stripe.com/docs/api/customer_portal/configuration
      });
      window.location.assign(data.url);
}

export async function activatePro(currentUser) {
    const docRef = await db
    .collection('customers')
    .doc(currentUser.uid)
    .collection('checkout_sessions')
    .add({
        price: 'price_1KOSS7G7Ue2VA7v767Z6gvM4', // prod price
        success_url: window.location.href+'?success=true',
        cancel_url: window.location.href+'?cancel=true',
        allow_promotion_codes: true
    });
    // Wait for the CheckoutSession to get attached by the extension
    docRef.onSnapshot((snap) => {
        const { error, url } = snap.data();
        if (error) {
            // Show an error to your customer and
            // inspect your Cloud Function logs in the Firebase console.
            alert(`An error occured: ${error.message}`);
        }
        if (url) {
            // We have a Stripe Checkout URL, let's redirect.
            window.location.assign(url);
        }
    });
    
}